import { useGetServerTime } from '@engoo/react-server-time';
import ServerTime from '@engoo/server-time';
import React, { ReactNode } from 'react';
import { Interval } from 'app/components/mixins/Timing';

interface IProps {
  children: (serverTime: Date) => ReactNode;
}

interface IPropsWithDeps extends IProps {
  getServerTime: ServerTime['getServerTime'];
}

interface IState {
  serverTimeSeconds: number;
}

/**
 * Re-renders children every second, when the server time changes, passing the current server time
 * as a Date.
 */
class GetServerTime extends React.PureComponent<IPropsWithDeps, IState> {
  public state = {
    serverTimeSeconds: this.getSeconds(new Date()),
  };

  public render() {
    return (
      <Interval ms={100} callback={this.updateTime}>
        {this.props.children(this.getDate())}
      </Interval>
    );
  }

  private getDate(): Date {
    return new Date(this.state.serverTimeSeconds * 1000);
  }

  private updateTime = () => {
    this.setState({
      serverTimeSeconds: this.getServerSeconds(),
    });
  };

  private getServerSeconds() {
    return this.getSeconds(this.props.getServerTime());
  }

  private getSeconds(date: Date) {
    return Math.floor(date.valueOf() / 1000);
  }
}

const GetServerTimeInjectDependencies: React.SFC<IProps> = (props) => {
  const getServerTime = useGetServerTime();
  return <GetServerTime {...props} getServerTime={getServerTime} />;
};

export default GetServerTimeInjectDependencies;
